import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail, Music2 } from "lucide-react";
import { BRAND } from "../lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#070707] border-t border-[#C9A34E]/15 pt-20 pb-8 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <img src={BRAND.logo} alt="Enrich" className="w-14 h-14 rounded-full object-cover ring-1 ring-[#C9A34E]/40" />
            <div>
              <div className="font-display text-2xl">Enrich</div>
              <div className="text-[10px] tracking-[0.32em] uppercase text-[#C9A34E]">Hair & Beauty</div>
            </div>
          </div>
          <p className="text-sm text-white/65 leading-relaxed max-w-sm">
            A luxury hair, skin & beauty studio in the heart of Pendle Hill, Sydney. Where elegance meets expertise.
          </p>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[#C9A34E] text-[11px] tracking-[0.3em] uppercase mb-5">Explore</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li><Link className="hover:text-[#C9A34E] transition-colors" to="/">Home</Link></li>
            <li><Link className="hover:text-[#C9A34E] transition-colors" to="/services">Services</Link></li>
            <li><Link className="hover:text-[#C9A34E] transition-colors" to="/gallery">Gallery</Link></li>
            <li><Link className="hover:text-[#C9A34E] transition-colors" to="/about">About</Link></li>
            <li><Link className="hover:text-[#C9A34E] transition-colors" to="/booking">Booking</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[#C9A34E] text-[11px] tracking-[0.3em] uppercase mb-5">Services</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li>Hair Colour & Highlights</li>
            <li>Keratin & Nanoplasty</li>
            <li>Facial Treatments</li>
            <li>Threading & Waxing</li>
            <li>Bridal Makeup & Hair</li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[#C9A34E] text-[11px] tracking-[0.3em] uppercase mb-5">Visit Us</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex gap-2"><MapPin size={16} className="text-[#C9A34E] mt-0.5 shrink-0" />{BRAND.address}</li>
            <li className="flex gap-2"><Phone size={16} className="text-[#C9A34E] mt-0.5 shrink-0" /><a href={`tel:${BRAND.phone}`} className="hover:text-[#C9A34E]">{BRAND.phone}</a></li>
            <li className="flex gap-2"><Mail size={16} className="text-[#C9A34E] mt-0.5 shrink-0" /><a href={`mailto:${BRAND.email}`} className="hover:text-[#C9A34E]">{BRAND.email}</a></li>
          </ul>
          <div className="flex gap-3 mt-6">
            <a data-testid="social-instagram" href={BRAND.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-[#C9A34E]/40 flex items-center justify-center text-[#C9A34E] hover:bg-[#C9A34E] hover:text-[#0B0B0B] transition-colors"><Instagram size={16} /></a>
            <a data-testid="social-facebook" href={BRAND.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-[#C9A34E]/40 flex items-center justify-center text-[#C9A34E] hover:bg-[#C9A34E] hover:text-[#0B0B0B] transition-colors"><Facebook size={16} /></a>
            <a data-testid="social-tiktok" href={BRAND.tiktok} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-[#C9A34E]/40 flex items-center justify-center text-[#C9A34E] hover:bg-[#C9A34E] hover:text-[#0B0B0B] transition-colors"><Music2 size={16} /></a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-3">
        <p className="text-xs text-white/45">© {new Date().getFullYear()} Enrich Hair & Beauty. All rights reserved.</p>
        <p className="text-xs text-white/45 tracking-widest uppercase">Crafted with elegance in Sydney</p>
      </div>
    </footer>
  );
}
